import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=2d53388a&"
import script from "./AccordionItem.vue?vue&type=script&lang=js&"
export * from "./AccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports